import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FadeUp, Stagger, StaggerItem } from '../components/Motion';
import api from '../lib/api';

export default function Partners() {
  const { t, i18n } = useTranslation();
  const lng = i18n.language?.startsWith('en') ? 'en' : 'fr';
  const [partners, setPartners] = useState([]);

  useEffect(() => { api.get('/partners').then((r) => setPartners(r.data)).catch(() => {}); }, []);

  return (
    <main data-testid="partners-page" className="pt-32">
      <section className="container-x max-w-7xl mx-auto pb-12">
        <FadeUp>
          <p className="overline">{t('partners.overline')}</p>
          <h1 className="mt-4 font-heading text-5xl sm:text-6xl lg:text-7xl text-ink tracking-tight max-w-4xl">{t('partners.title')}</h1>
          <p className="mt-6 text-lg text-ink-soft max-w-2xl leading-relaxed">{t('partners.intro')}</p>
        </FadeUp>
      </section>

      <section className="container-x max-w-7xl mx-auto pb-24">
        <Stagger className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {partners.map((p) => (
            <StaggerItem key={p.id}>
              <div className="bg-white border border-border-soft rounded-3xl p-8 hover-lift h-full" data-testid={`partner-${p.id}`}>
                <div className="font-mono text-xs text-earth uppercase tracking-widest">Partner</div>
                <h3 className="mt-3 font-heading text-2xl text-ink">{p.name}</h3>
                <p className="mt-3 text-ink-soft leading-relaxed">{p[`description_${lng}`]}</p>
                {p.website && (
                  <a href={p.website} target="_blank" rel="noreferrer" className="mt-5 inline-block text-forest text-sm font-medium border-b border-forest/40 pb-0.5 hover:border-forest">
                    {p.website.replace(/^https?:\/\//, '')}
                  </a>
                )}
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </section>
    </main>
  );
}
